import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Input, Select } from 'antd';
import axios from 'axios';

function Admin() {
    const [password, setPassword] = useState('');
    const [LangcodeASR, setLangcodeASR] = useState('en-US');
    const [LangcodeTTS, setLangcodeTTS] = useState('en-US');
    const [SavePCM, setSavePCM] = useState(false);

    useEffect(() => {
        async function fetchAdminInfo() {
            const res = await axios.post('/api/get_admin_info', {});
            if (res.success) {
                setLangcodeASR(res.data.langcode_asr);
                setLangcodeTTS(res.data.langcode_tts);
                setSavePCM(res.data.save_pcm);
            }
        }

        fetchAdminInfo();
    }, []);

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleLangcodeASRChange = (value) => {
        setLangcodeASR(value);
    };

    const handleLangcodeTTSChange = (value) => {
        setLangcodeTTS(value);
    };

    const handleSavePCMChange = (value) => {
        setSavePCM(value);
    };

    async function updateAdminInfo() {
        const admin_info_data = {
            password: password,
            langcode_asr: LangcodeASR,
            langcode_tts: LangcodeTTS,
            save_pcm: SavePCM
        };
        const res = await axios.post('/api/set_admin_info', {'admin_info': admin_info_data});
        if (res.success) {
            console.log('Admin info updated:', res.data);
        } else {
            alert('Failed to update admin info');
        }
    };

    return (
        <div>
            <h1>Admin</h1>
            <Row justify="center" align="middle" style={{ marginBottom: '20px' }}>
                <Col style={{ marginRight: '10px' }}>
                    Input Language:
                </Col>
                <Col>
                    <Select value={LangcodeASR} onChange={handleLangcodeASRChange}>
                        <Select.Option value="en-US">en-US</Select.Option>
                        <Select.Option value="ko-KR">ko-KR</Select.Option>
                        <Select.Option value="ja-JP">ja-JP</Select.Option>
                    </Select>
                </Col>
            </Row>
            <Row justify="center" align="middle" style={{ marginBottom: '20px' }}>
                <Col style={{ marginRight: '10px' }}>
                    Output Language:
                </Col>
                <Col>
                    <Select value={LangcodeTTS} onChange={handleLangcodeTTSChange}>
                        <Select.Option value="en-US">en-US</Select.Option>
                        <Select.Option value="ko-KR">ko-KR</Select.Option>
                        <Select.Option value="ja-JP">ja-JP</Select.Option>
                    </Select>
                </Col>
            </Row>
            <Row justify="center" align="middle" style={{ marginBottom: '20px' }}>
                <Col style={{ marginRight: '10px' }}>
                    Save PCM:
                </Col>
                <Col>
                    <Select value={SavePCM} onChange={handleSavePCMChange}>
                        <Select.Option value={true}>Yes</Select.Option>
                        <Select.Option value={false}>No</Select.Option>
                    </Select>
                </Col>
            </Row>
            <Row justify="center" align="middle" style={{ marginBottom: '20px' }}>
                <Col style={{ marginRight: '10px' }}>
                    <Input type="password" value={password} placeholder="Password" onChange={handlePasswordChange} />
                </Col>
                <Col>
                    <Button type="primary" onClick={updateAdminInfo}>Write Admin Info</Button>
                </Col>
            </Row>
            <Row justify="center" align="middle" style={{ marginBottom: '20px' }}>
                <Col>
                    (서버 재시작하면 지워지므로 다시 세팅 필요)
                </Col>
            </Row>
        </div>
    );
}

export default Admin
